import { useEffect } from 'react';
import { create } from 'zustand';

export interface TrailItem {
  label: string;
  /** Адрес крошки; без него крошка — просто текст (обычно последняя). */
  href?: string;
}

interface TrailState {
  items: TrailItem[];
  set: (items: TrailItem[]) => void;
}

const useTrailStore = create<TrailState>()((set) => ({
  items: [],
  set: (items) => {
    set({ items });
  },
}));

/**
 * Хвост хлебных крошек, который знает только экран.
 *
 * Сайт, окружение и раздел оболочка выводит из адреса сама. Название
 * записи в адресе не лежит — его знает экран записи, когда она загрузится,
 * и сообщает сюда. Уход с экрана хвост убирает.
 */
export function useTrail(items: TrailItem[]): void {
  const set = useTrailStore((state) => state.set);
  const key = JSON.stringify(items);

  useEffect(() => {
    set(JSON.parse(key) as TrailItem[]);

    return () => {
      set([]);
    };
  }, [key, set]);
}

export function useTrailItems(): TrailItem[] {
  return useTrailStore((state) => state.items);
}
